import { shallowEqual } from 'react-redux'

import { State } from 'store/state'

import { useAppSelector } from '../store/hooks'

export enum Roles {
  ADMIN = 'admin',
  OWNER = 'owner',
}

export const useAuthRoles = () => {
  const { roles } = useAppSelector(
    (state: State) => ({
      roles: state.authReducer.user?.roles ?? [],
    }),
    shallowEqual
  )

  return {
    isAdmin: roles?.includes(Roles.ADMIN),
    isOwner: roles?.includes(Roles.OWNER),
  }
}
